/**
 * GMA-1622 (CompassCare Web 7/14) — Dispatch route container.
 *
 * Mounts the app-shell (WebShell) around the call-trees & escalation page
 * (DispatchPage) at /web/dispatch, wiring sidebar navigation to the router.
 * This is the route scaffolding: live call-tree management + the real audit
 * feed (Caregiver Admin backend) is a deliberate follow-up, so until then the
 * page renders the demo library in demo builds and its calm empty state
 * otherwise, inside a real, navigable frame.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import WebShell from "../../components/web/WebShell";
import DispatchPage from "./DispatchPage";
import {
  DEMO_DATA_ENABLED,
  getDemoCallTrees,
  getDemoContactAttempts,
} from "./demoData";

export default function WebDispatchRoute() {
  const navigate = useNavigate();
  // Capture one timestamp so demo-attempt generation and relative-time UI
  // agree (matches the other /web route containers).
  const now = Date.now();
  const trees = DEMO_DATA_ENABLED ? getDemoCallTrees() : [];
  const attempts = DEMO_DATA_ENABLED ? getDemoContactAttempts(now) : [];
  return (
    <WebShell
      activeKey="dispatch"
      onNavigate={(section) => {
        if (section && section.path) navigate(section.path);
      }}
      title="Dispatch"
    >
      <DispatchPage trees={trees} attempts={attempts} now={now} />
    </WebShell>
  );
}
